import _ from 'lodash';
_.noConflict();

function buildFractionalIndexMap (targetArray, itemsToAdd, defaultItemsSorting) {
  const itemsToAddSet = new Set(itemsToAdd);

  // key -- column, value -- fractional index in resulting array
  const targetArrayIndexMap = {null: -1};
  targetArray.forEach((key, index) => {
    targetArrayIndexMap[key] = index;
  });

  const precedingToAddMap = {};
  let currentTargetItem = null;
  let itemsToAddAfterCurrentTargetItem = [];
  defaultItemsSorting.forEach((key, index, allKeys) => {
    if (itemsToAddSet.has(key)) {
      itemsToAddAfterCurrentTargetItem.push(key);
    }
    if (targetArrayIndexMap[key] !== undefined || index === allKeys.length - 1) {
      if (itemsToAddAfterCurrentTargetItem.length > 0) {
        precedingToAddMap[currentTargetItem] = itemsToAddAfterCurrentTargetItem;
        itemsToAddAfterCurrentTargetItem = [];
      }
      currentTargetItem = key;
    }
  });
  Object.entries(precedingToAddMap).forEach(([prevKey, newColumnsBatch]) => {
    newColumnsBatch.forEach((column) => {
      // calc fractional index of every column
      targetArrayIndexMap[column] = targetArrayIndexMap[prevKey] + 0.5;
    });
  });
  return targetArrayIndexMap;
}

function addItemsToArrayPreserveSorting (targetArray, itemsToAdd, defaultItemsSorting) {
  const fractionalIndexMap = buildFractionalIndexMap(targetArray, itemsToAdd, defaultItemsSorting);
  const unsortedResult = targetArray.concat(itemsToAdd);
  return _.sortBy(unsortedResult, column => fractionalIndexMap[column]);
}

export default addItemsToArrayPreserveSorting;
